import { fetchDashboardActivity } from '@/lib/dashboard-api';

export interface ActivityItem {
  id: string;
  type: 'task' | 'daily_log' | 'purchase_order' | 'bill' | 'comment';
  title: string;
  description: string;
  timestamp: string;
  actualTimestamp: string; // the ISO timestamp the list is ordered by
  user_name?: string;
  project_name?: string;
}

/** The latest activity of the company (or of one project); the backend (GET /api/dashboard/activity) chooses, scopes and orders it. */
export async function fetchRecentActivity(selectedProject?: string, limit: number = 4): Promise<ActivityItem[]> {
  try {
    const items = await fetchDashboardActivity(selectedProject, limit);
    return items.map((item) => ({
      id: item.id,
      type: item.type,
      title: item.title,
      description: item.description,
      timestamp: formatTimestamp(item.actual_timestamp),
      actualTimestamp: item.actual_timestamp,
      user_name: item.user_name,
      project_name: item.project_name,
    }));
  } catch (error) {
    console.error('Error fetching recent activity:', error);
    return [];
  }
}

function formatTimestamp(timestamp: string): string {
  const date = new Date(timestamp);
  const now = new Date();
  const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));

  if (diffInHours < 1) {
    return 'Just now';
  } else if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  } else if (diffInHours < 48) {
    return 'Yesterday';
  } else {
    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  }
}
